// client/src/main.js
import './assets/main.css'

// Vue
import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App)

// Event Bus
import mitt from 'mitt';
const eventBus = mitt();
app.config.globalProperties.$eventBus = eventBus;

// VueUse Head for managing document head
import { createHead } from '@vueuse/head'
const head = createHead()
app.use(head)

// Vue Router
import router from './router.js'
app.use(router)

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
const myCustomLightTheme = {
  dark: false,
  colors: {
    primary: '#1992D4',
    secondary: '#5ccfcbff',
    background: '#FFFFFF',
    surface: '#eff4f7ff',
    surfaceOn: '#9dddffff',
    lightSurface: '#f3f9fdff',
    error: '#CF1124',
    info: '#FADB5F',
    success: '#27AB83',
    warning: '#F86A6A',
    border: '#d5d5d5ff',
    'text-subtle': '#888888',
  },
  variables: {
    'text-primary': '#000000',
    'text-secondary': '#888888',
    'text-tertiary': '#555555',
    'text-disabled': '#cccccc',
    'text-on-primary': '#ffffff',
    'text-on-secondary': '#000000',
    'text-on-surface': '#000000',
  }
}

const vuetify = createVuetify({
  theme: {
    defaultTheme: 'myCustomLightTheme',
    variations: {
      colors: ['primary', 'secondary'],
      lighten: 1,
      darken: 2,
    },
    themes: {
      myCustomLightTheme,
    },
  }
})
app.use(vuetify)

// Pinia
import { createPinia } from 'pinia'
const pinia = createPinia()
app.use(pinia)


app.mount('#app')